import { useCallback, useState } from "react";
import type { LayoutChangeEvent } from "react-native";
import type { ViewProps } from "tamagui";

const getRadiusForHeight = (heightPx: number): ViewProps["borderRadius"] => {
  // Heuristic: decrease radius as height increases
  // < 40px => $10; then step down, bottoming at $7
  if (heightPx < 40) {
    return "$10";
  }
  if (heightPx < 60) {
    return "$9";
  }
  if (heightPx < 80) {
    return "$8";
  }
  return "$7";
};

export const useDynamicBorderRadius = () => {
  const [measuredHeight, setMeasuredHeight] = useState(0);

  const handleLayout = useCallback((layoutEvent: LayoutChangeEvent) => {
    const { height } = layoutEvent.nativeEvent.layout;
    setMeasuredHeight(height);
  }, []);

  const borderRadius = getRadiusForHeight(measuredHeight);

  return {
    borderRadius,
    handleLayout,
  };
};
